/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useCreateOrganizationOverlayFormStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  title: {
    lineHeight: '38px',
    marginBottom: '40px',
  },
  subtitle: {
    '&:first-child': {
      margin: '0px 8px',
    },
    margin: '15px 8px',
  },
  helperText: {
    '& .MuiFormHelperText-root': {
      padding: '0 0 0 5px',
    },
  },
}));
